<template>
  <page-outline 
    :title="listTitle"
    :show-filter="true"
    :show-refresh="true"
    :filter-expanded="displayFilter"
    :refresh-disabled="activateSpinner"
    @toggle-filter="toggleFilter"
    @refresh="onRefresh">
    
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
      <app-button
        :text="$t('common.vop_provider.add_vop_provider')"
        icon="fa-light fa-plus"
        variant="primary"
        @click="actionAdd">
      </app-button>
    </template>
    
    <template slot="filterContent">
      <app-panel
        :filters="filterConfig"
        :searchAriaLabel="$t('common.srch') + ' ' + $t('common.vop_provider.vop_provider')"
        @filter-changed="onFilterChanged"
        @clear-filters="clearFilterFields"
        @apply-filters="onRefresh"
      />
    </template>
    
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-row class="mb-5">
          <b-col cols="12">
            <div style="overflow:auto">
              <spinner v-if="activateSpinner"></spinner>
              <b-table v-else-if="listItemsVopProvider.length > 0"
                :items="listItemsVopProvider"
                :fields="fields"
                class="table-striped"
                hover
                :selectable="listItemsVopProvider.length > 0"
                :empty-text="$t('common.security.no_result')"
                style="margin-bottom:0"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable"
                @row-selected="onRowClicked"
                :key="refreshKey">
                <template #cell(NameVopProvider)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(edit)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdVopProvider)">
                    <i class="fa-regular fa-pencil"></i>
                  </span>
                </template>
                <template #cell(delete)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdVopProvider)">
                    <i class="fa-regular fa-trash"></i>
                  </span>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import Pagination from '@/components/common/pagination.vue'
import moment from 'moment-timezone'
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import AppButton from '@/components/common/AppButton.vue'
import AppPanel from '@/components/common/AppPanel.vue'
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"

export default {
  name: "VopProviderPage",
  components: {
    'app-button': AppButton,
    'app-panel': AppPanel,
    'cm-pagination': Pagination,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      displayFilter: false,
      filterConditions: {},
      listItemsVopProvider: [],
      listTitle: "",
      NameVopProvider: '',
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      returnUrl: '',
      sortBy: '',
      sortDir: false,
      filterValues: {
        NameVopProvider: ''
      }
    }
  },
  created() {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.role = this.$route.query.role
    if (this.role === '1') {
      this.returnUrl = '/routing/configlist/1/0/rvm'
    } else if (this.role === '0') {
      this.returnUrl = '/routing/configlist/0/0/rvm'
    } else {
      this.returnUrl = '/entitiessettings/rvm/BICRVM'
    }

    this.listTitle = this.$i18n.t("common.vop_provider.vop_provider")
    this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getVopProvider(index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.getVopProvider()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    filterConfig() {
      return [
        {
          id: 'filter-name',
          type: 'text',
          prop: 'NameVopProvider',
          labelKey: 'common.vop_provider.name',
          icon: 'fa-solid fa-building',
          value: this.filterValues.NameVopProvider,
          colSm: '12',
          colLg: '12'
        }
      ]
    },
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []
      fields.push({
        key: 'NameVopProvider',
        label: this.$t('common.vop_provider.name'),
        class: 'text-center',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), class: 'text-center', sortable: false })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), class: 'text-center', sortable: false })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      loadPage(this, {url: '/vopProvider/add/-1'})
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.vop_provider.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { IdVopProvider: id }
              that.$engine.firstOn().vopProvider.deleteVopProvider(params)
              .then(resp => {
                that.listItemsVopProvider = that.listItemsVopProvider.filter(item => item.IdVopProvider !== id)
                that.$f7.modal({
                  title: that.$t('common.vop_provider.vop_provider_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: '/vopProvider/' })
              })
              .catch((e) => {
                if (e.response.status === 400 && e.response.data.errors) {
                  const errors = e.response.data.errors

                  errors.forEach((error) => {
                    if (error.error === "Deletion Error") {
                      that.okMessageBox(that.$t('common.vop_provider.unable_del'))
                    }
                  })
                } else {
                    errorMessageAlert(e, that, that.$i18n)
                    that.okMessageBox(that.$t('common.vop_provider.vop_provider_delete_error'))
                }
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/vopProvider/edit/' + id })
    },
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getVopProvider()
    },
    clearFilterFields() {
      this.NameVopProvider = ''
      this.filterValues.NameVopProvider = ''
    },
    onFilterChanged({ prop, value }) {
      this.filterValues[prop] = value
      if (prop === 'NameVopProvider') {
        this.NameVopProvider = value
      }
    },
    toggleFilter() {
      this.displayFilter = !this.displayFilter
    },
    getVopProvider(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        NameVopProvider: this.NameVopProvider,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.firstOn().vopProvider.getVopProvider(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.VopProvider.length

        let vopProviderList = {}

        vopProviderList = resp.data.VopProvider

        that.updateVopProvider(vopProviderList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getVopProvider()
    },
    onRowClicked(item) {
      if (item[0] && item[0].IdVopProvider) {
        loadPage(this, { url: '/vopProvider/details/' + item[0].IdVopProvider })
      }
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'NameVopProvider'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateVopProvider(vopProviderList) {
      this.listItemsVopProvider = vopProviderList
    },
    goBack() {
      if (this.returnUrl) {
        loadPage(this, {url: this.returnUrl})
      } else {
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
          loadPage(this, {url: '/home/'})
        } else {
          if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === this.$f7.mainView.history[this.$f7.mainView.history.length - 1]) {
            loadPage(this, {url: '/home/'})
          } else {
            this.$f7.mainView.router.back()
          }
          this.$bus.$emit('router-back')
        }
      }
    }
  }
}
</script>

<style scoped>

@media (max-width: 1400px) {
  .responsive-button {
    min-height: 70px;
  }
}
</style>
